module.exports = __webpack_public_path__ + "static/BickhamScriptPro-Regular-a77b740f8974174e3efc0ed7ed1a204d.woff2";